@defer {
  <app-header></app-header>
}
<div [@viewTransitionMain]="getAnimationState(outlet)" class="app-router-container">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
@defer {
  <app-main-menu></app-main-menu>
  <app-loading></app-loading>
  <app-alert></app-alert>

  <!-- remove ads - popup -->
  <app-lib-dialog
    [titleText]="'more.ads.annoyed.title' | translate"
    [hasCloseButton]="false"
    [hasOkCancelButton]="true"
    [okText]="'more.ads.annoyed.submit' | translate"
    [cancelText]="'more.ads.annoyed.cancel' | translate"
    [show]="showAnnoyedAdsPopup"
    (okClicked)="goToAdsPage()"
    (cancelClicked)="showAnnoyedAdsPopup = false"
  >{{ "more.ads.annoyed.text" | translate }}
  </app-lib-dialog>

  <!-- push notification - popup -->
  <app-lib-dialog
    [titleText]="activePushNotification?.title || activePushNotification?.notification?.title || ''"
    [hasCloseButton]="!activePushNotificationHasLink"
    [hasOkCancelButton]="activePushNotificationHasLink"
    [okText]="'push.popup.submit' | translate"
    [cancelText]="'common.close' | translate"
    [show]="showPushNotification"
    (okClicked)="pushNotificationOpenUrl()"
    (cancelClicked)="showPushNotification = false"
  >
    <div class="app__push-notification-dialog">
      <p>{{ activePushNotification?.body || activePushNotification?.notification?.body }}</p>
    </div>
  </app-lib-dialog>

  <!-- conflicting rehearsal - popup -->
  <app-lib-dialog
    [titleText]="'rehearsal.conflict.title' | translate"
    [hasCloseButton]="false"
    [okText]="'rehearsal.conflict.start-button' | translate"
    [cancelText]="'rehearsal.conflict.go-contest-button' | translate"
    [show]="showConflictRehearsalPopup"
    (okClicked)="conflictRehearsalStartRehearsal()"
    (cancelClicked)="conflictRehearsalGoToContest()"
  >{{ 'rehearsal.conflict.text' | translate:{contestHour: conflictingRehearsalEvent?.startAt | date:'HH:mm'} }}
  </app-lib-dialog>
}
